export default __webpack_public_path__ + "static/logo-geek-af44460b0b7d1251f2b38c26ee8e5e2b.png";